import { z } from "zod";
/** Bounded reading of an already persisted next-check intention. System-built
 * lead-magnet checks include a title (up to 200 characters) and can exceed the
 * 600-character limit for new manual/model scheduling directives. Keep their
 * complete text in operator snapshots and the job/model input context.
 * This schema does not validate new scheduling mutations or model output. */
export const StoredNextCheckIntentionSchema = z.string().max(2_000);
//# sourceMappingURL=next-check.js.map